<template>
  <a href="/maplestory" @click="btnClick"><div class="m-headingForT-go-to-main-btn"></div></a>
</template>

<script setup>
  import { useGAEventStore } from '@/store/GAEventTracking'
  const gaEvent = useGAEventStore()

  function btnClick() {
    gaEvent.pushActionEvent({
      interaction: 'button_click',
      micrositeSectionNumber: 0,
      micrositeSectionContent: 'Go To Main Button',
      micrositeSectionName: 'Side Nav',
    })
  }
</script>

<style scoped lang="scss">
  .m-headingForT-go-to-main-btn {
    right: 2vw;
    bottom: 4vw;
    position: fixed;
    z-index: 100;
    width: 4vw;
    height: 3.8vw;
    background: red;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/go-to-main/go-to-main.png') no-repeat
      center center / 100% auto;
    cursor: pointer;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/go-to-main/go-to-main-hover.png');
    }
  }
  .tablet {
    .m-headingForT-go-to-main-btn {
      width: 11vw;
      height: 9vw;
      right: 4vw;
      bottom: 4vw;
    }
  }
  .mobile {
    .m-headingForT-go-to-main-btn {
      display: none;
    }
  }
</style>
